import { action, makeObservable, observable } from 'mobx';

class GameStore {
  isBetsClosed = false;

  gameAnimationDuration = 0;

  numPadData = { isOpen: false, sectionName: null, currentInputValue: null };

  timerDuration = 10;

  isRoundFinishedHandled = false;

  isPongReceived = false;

  isLoadingPage = false;

  gameState = {
    status: '',
    isInitialLoaded: false,
  };

  constructor() {
    makeObservable(this, {
      gameState: observable,
      isBetsClosed: observable,
      timerDuration: observable,
      isLoadingPage: observable,
      isRoundFinishedHandled: observable,
      isPongReceived: observable,
      numPadData: observable.deep,
      setGameState: action.bound,
      setNumPadData: action.bound,
      setIsBetsClosed: action.bound,
      setTimerDuration: action.bound,
      setIsRoundFinishedHandled: action.bound,
      setIsPongReceived: action.bound,
      setIsLoadingPage: action.bound,
      setGameAnimationDuration: action.bound,
    });
  }

  setIsBetsClosed(isBetsClosed) {
    this.isBetsClosed = isBetsClosed;
  }

  setNumPadData(data) {
    this.numPadData = data;
  }

  setIsRoundFinishedHandled(bool) {
    this.isRoundFinishedHandled = bool;
  }

  setTimerDuration(timeValue) {
    this.timerDuration = timeValue;
  }

  setGameState(status) {
    this.gameState = status;
  }

  setIsPongReceived(isPongReceived) {
    this.isPongReceived = isPongReceived;
  }

  setIsLoadingPage(isLoadingPage) {
    this.isLoadingPage = isLoadingPage;
  }

  setGameAnimationDuration(bool) {
    this.gameAnimationDuration = bool;
  }
}

export const gameStore = new GameStore();
